import React, { FC } from 'react'

export const ShortsIcon: FC = () => {
    return (
        <svg
            viewBox="0 0 56 56"
            width="100%"
            height="100%"
            aria-hidden="true"
            focusable="false"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="56" height="56" rx="28" fill="#DDD9E5" />
            <path
                d="M23.625 22.6893C23.625 21.8541 23.625 21.4365 23.7995 21.2033C23.9517 21.0001 24.1845 20.873 24.4377 20.8549C24.7282 20.8342 25.0795 21.06 25.7821 21.5117L34.0431 26.8223C34.6528 27.2143 34.9576 27.4103 35.0629 27.6594C35.1549 27.8772 35.1549 28.1228 35.0629 28.3406C34.9576 28.5897 34.6528 28.7857 34.0431 29.1777L25.7821 34.4883C25.0795 34.94 24.7282 35.1658 24.4377 35.1451C24.1845 35.127 23.9517 34.9999 23.7995 34.7967C23.625 34.5635 23.625 34.1459 23.625 33.3107V22.6893Z"
                stroke="#31173D"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.25 20.65C12.25 17.7097 12.25 16.2396 12.8222 15.1165C13.3256 14.1287 14.1287 13.3256 15.1165 12.8222C16.2396 12.25 17.7097 12.25 20.65 12.25H35.35C38.2903 12.25 39.7604 12.25 40.8834 12.8222C41.8713 13.3256 42.6744 14.1287 43.1778 15.1165C43.75 16.2396 43.75 17.7097 43.75 20.65V35.35C43.75 38.2903 43.75 39.7604 43.1778 40.8834C42.6744 41.8713 41.8713 42.6744 40.8834 43.1778C39.7604 43.75 38.2903 43.75 35.35 43.75H20.65C17.7097 43.75 16.2396 43.75 15.1165 43.1778C14.1287 42.6744 13.3256 41.8713 12.8222 40.8834C12.25 39.7604 12.25 38.2903 12.25 35.35V20.65Z"
                stroke="#31173D"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
